import { createSlice } from "@reduxjs/toolkit";
import { updateEnrollmentAgreementStatusAPI } from "../../services/updateEnrollmentAgreementStatus";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  updatingId: null,
};

const updateEnrollmentAgreementStatusSlice = createSlice({
  name: "updateEnrollmentAgreementStatus",
  initialState,
  reducers: {
    updateEnrollmentAgreementStatusInfo(state, action) {
      state.isLoading = true;
      state.updatingId = action?.payload?.enrollmentAgreementId ?? null;
      state.error = "";
      state.message = "";
    },
    updateEnrollmentAgreementStatusInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = "";
      state.message = "Status updated successfully";
      state.updatingId = null;
    },
    updateEnrollmentAgreementStatusInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      state.error = action.payload;
      state.data = null;
      state.updatingId = null;
    },
    updateEnrollmentAgreementStatusInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.updatingId = null;
    },
  },
});

export const updateEnrollmentAgreementStatusHandler =
  (payload) => async (dispatch) => {
    try {
      dispatch(
        updateEnrollmentAgreementStatusAction.updateEnrollmentAgreementStatusInfo(
          payload,
        ),
      );
      const response = await updateEnrollmentAgreementStatusAPI(payload);
      dispatch(
        updateEnrollmentAgreementStatusAction.updateEnrollmentAgreementStatusInfoSuccess(
          response,
        ),
      );
    } catch (e) {
      dispatch(
        updateEnrollmentAgreementStatusAction.updateEnrollmentAgreementStatusInfoFailure(
          e?.response?.data?.message || e?.message || String(e),
        ),
      );
    }
  };

export default updateEnrollmentAgreementStatusSlice.reducer;
export const updateEnrollmentAgreementStatusAction =
  updateEnrollmentAgreementStatusSlice.actions;

